"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParagraphTextLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ParagraphTextLayout = ({
  banner,
  debug,
  modulePosition,
  className
}) => {
  const {
    layout,
    modules
  } = banner;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  if (!modules || modules.length < 1) {
    return (0, _utils.getModulesLengthError)({
      debug,
      layout,
      modulePosition
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.ParagraphText),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.TextBox, {
      titleMaxLines: isMobile ? 5 : 4,
      titleVariant: "h4",
      module: modules[0]
    })
  });
};
exports.ParagraphTextLayout = ParagraphTextLayout;
